import styled from 'styled-components'

function BaseMenuIcon({ className, size = 24, ...rest }: IconComponentProps) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      {...rest}
    >
      <path d="M3 18h18v-2H3zm0-5h18v-2H3zm0-7v2h18V6z" fill="currentColor" />
    </svg>
  )
}

export const MenuIcon = styled(BaseMenuIcon)`
  flex-shrink: 0;
`
